import { Trans, useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

import Button from 'src/components/atoms/button'
import { routes } from 'src/routes/routes'
import { useUI } from 'src/state/uiState'

import { Result } from 'antd'

export default function NotFound() {
    const { t } = useTranslation()
    const ui = useUI()
    const navigate = useNavigate()

    // TODO Check for correct url for contact helpdesk
    return (
        <div className="flex h-screen w-full items-center justify-center" data-testid="404-page">
            <Result
                status="404"
                title="404"
                subTitle={
                    <div className="flex flex-col">
                        <div className="text-lg font-medium text-black">
                            {t('It looks like you tried to access a non-existing page.')}
                        </div>
                        <div>
                            <Trans>
                                If you are sure this should not happened, please
                                <Link to="/" style={{ color: ui.colors.primary }}>
                                    {' '}
                                    contact our helpdesk
                                </Link>
                            </Trans>
                        </div>
                    </div>
                }
                extra={
                    <Button type="primary" onClick={() => navigate(routes.HOME)}>
                        {t('Go to home')}
                    </Button>
                }
            />
        </div>
    )
}
